import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  &&& {
    vertical-align: middle;
    background-color: #f3f3f3;
    border: 1px solid #e7e7e7;
    color: #000;
    padding: 15px;
    text-align: center;
  }

  * {
    vertical-align: middle;
  }

  h2 {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 45px;
  }

  h4 {
    font-size: 15px;
    font-weight: bold;
  }
`;

const TextBoxArea = ({ className, children }) => {
  return (
    <StyledDiv className={className}>
      <div>{children}</div>
    </StyledDiv>
  );
};

export default TextBoxArea;
